import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";

// Component Imports
import ViewSupervisors from "./ViewSupervisor";
import CreateSupervisor from "./CreateSupervisor";
import MapSiteSupervisor from "./MapSiteToSupervisor";

const steps = ["View Supervisors", "Create Supervisor", "Map Site to Supervisor"];

export default function ManageSupervisorWizard() {
  const [activeStep, setActiveStep] = useState(0);

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return <ViewSupervisors />;
      case 1:
        return <CreateSupervisor />;
      case 2:
        return <MapSiteSupervisor />;
      default:
        return null;
    }
  };

  return (
    <Box
      className="manage-supervisor-wrapper"
      sx={{ maxWidth: 1500, mx: "auto", py: 4, px: 2 }}
    >
      <Typography
        variant="h5"
        sx={{
          mb: 4,
          fontWeight: "bold",
          textAlign: "left",
          borderBottom: "2px solid #1976d2",
          display: "inline-block",
          color: "#060606",
          pb: 0.5 // Matching the visual padding of the reference
        }}
      >
        Manage Supervisors
      </Typography>

      {/* Wizard Stepper */}
      <Card
        sx={{
          p: 2,
          mb: 2, // Adjusted to match the ManageSiteWizard spacing
          borderRadius: 3,
          boxShadow: 4,
        }}
      >
        <Stepper activeStep={activeStep} alternativeLabel nonLinear>
          {steps.map((label, index) => (
            <Step key={label}>
              <StepLabel
                onClick={() => setActiveStep(index)}
                 StepIconProps={{
                  sx: {
                    cursor: "pointer",
                    fontWeight: "bold",
                    color: "grey.400",

                     "& .MuiStepIcon-text": {
        fill: "#000",
        fontWeight: "bold",
      },
                    "&.Mui-active": {
                       color: "#EE7F1A",
                      transform: "scale(1.3)",
                      transition: "all 0.3s",
                    },
                    "&.Mui-completed": {
                     color: "#EE7F1A",
                    },
                  },
                }}
                sx={{
                  cursor: "pointer",
                  "&:hover": { color: "primary.light", fontWeight: "bold" },
                }}
              >
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Card>

      {/* Animated Step Content */}
      <AnimatePresence mode="wait">
        <motion.div
          key={activeStep}
          initial={{ opacity: 0, x: 50 }} // Using horizontal shift from reference
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -50 }}
          transition={{ duration: 0.4 }}
        >
          <Paper
            elevation={6}
            sx={{
              p: 1, // Compact padding from reference
              borderRadius: 3,
              minHeight: 400,
              mb: 1,
               background: "linear-gradient(135deg, #bdbdbd 10%, #f8fafd 80%)", // Gradient from reference
            }}
          >
            {/* Inner padding container for content clarity */}
            <Box sx={{ p: 2 }}>
                {renderStepContent(activeStep)}
            </Box>
          </Paper>
        </motion.div>
      </AnimatePresence>
    </Box>
  );
}